import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { ISearchAPIPayload } from "../../../redux/types/common";

import { usersColumns } from "../../../utils/constants";
import { IconButton, Tooltip } from "@mui/material";
import TableHeader from "../../TableHeader";
import { EditRounded, VisibilityRounded } from "@mui/icons-material";
import {
  getAllUsers,
  onChangeUserList,
  onChangeUsersScreen,
  onSelectUser,
} from "../../../redux/slices/users.slice";
import TableListFrontend from "../../TableListFrontend";

const UsersList = () => {
  const { data, loading, pageProps } = useSelector(
    (state: RootState) => state.users
  );

  const dispatch = useDispatch<AppDispatch>();

  const actionItems = () => {
    return (
      <>
        {data?.map((row, idx) => (
          <div key={idx} className="flex justify-center items-center">
            <Tooltip title="View">
              <IconButton
                onClick={() => {
                  dispatch(onSelectUser(row));
                  dispatch(onChangeUsersScreen("view"));
                }}
                color="primary"
              >
                <VisibilityRounded />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit" key={idx}>
              <IconButton
                onClick={() => {
                  dispatch(onSelectUser(row));
                  dispatch(onChangeUsersScreen("edit"));
                }}
                color="primary"
              >
                <EditRounded />
              </IconButton>
            </Tooltip>
          </div>
        ))}
      </>
    );
  };

  return (
    <div>
      <TableHeader
        title="Users"
        onPageChange={(data: ISearchAPIPayload) => {
          dispatch(onChangeUserList(data));
        }}
        onBtnAction={() => dispatch(onChangeUsersScreen("add"))}
        loading={loading}
        pageProps={pageProps}
        onRefreshData={(data: ISearchAPIPayload) => {
          dispatch(getAllUsers());
          dispatch(onChangeUserList(data));
        }}
      />
      <TableListFrontend
        columns={usersColumns}
        data={data}
        actionsRows={actionItems()}
        searchQuery={pageProps?.searchText}
      />
    </div>
  );
};

export default UsersList;
